module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-2880ac58.svg";